import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function BusinessImpactIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_business_impact)">
        <path
          d="M12.3333 6.49996C12.3333 6.03972 11.9602 5.66663 11.5 5.66663H4.49996C4.03972 5.66663 3.66663 6.03972 3.66663 6.49996V11.5C3.66663 11.9602 4.03972 12.3333 4.49996 12.3333H11.5C11.9602 12.3333 12.3333 11.9602 12.3333 11.5V6.49996ZM13.3333 11.5C13.3333 12.5125 12.5125 13.3333 11.5 13.3333H4.49996C3.48744 13.3333 2.66663 12.5125 2.66663 11.5V6.49996C2.66663 5.48744 3.48744 4.66663 4.49996 4.66663H11.5C12.5125 4.66663 13.3333 5.48744 13.3333 6.49996V11.5Z"
          fill="currentColor"
        />
        <path
          d="M9.66663 12.5V4.49996C9.66663 4.03972 9.29355 3.66663 8.83329 3.66663H7.16663C6.70639 3.66663 6.33329 4.03972 6.33329 4.49996V12.5C6.33329 12.7761 6.10944 13 5.83329 13C5.55715 13 5.33329 12.7761 5.33329 12.5V4.49996C5.33329 3.48744 6.1541 2.66663 7.16663 2.66663H8.83329C9.84584 2.66663 10.6666 3.48744 10.6666 4.49996V12.5C10.6666 12.7761 10.4428 13 10.1666 13C9.89048 13 9.66663 12.7761 9.66663 12.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_business_impact">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
